import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AppState, BulkOrdersActionTypes, getBulkOrderByOrderId } from '@app/core/ngrx';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Sort, MatSortModule } from '@angular/material/sort';
import { HelperService } from '@app/core/services';

@Component({
  selector: 'ecp-bulk-order-details',
  templateUrl: './bulk-order-details.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  styleUrls: ['./bulk-order-details.component.scss'],
})
export class BulkOrderDetailsComponent implements OnInit {
  bulkOrderLineItems: any = null;
  orderItems$: Observable<any>;
  orderDetails: any = null;
  loading: boolean = true;
  constructor(private store: Store<AppState>, private _activeRoute: ActivatedRoute, private helper: HelperService) {
    this.viewOrderDetails();
  }
  formatFileName(title: string) {
    return title.replace(/[_-]/g, ' ');
  }
  ngOnInit(): void {
    this.loading = true;
  }
  viewOrderDetails() {
    let bulkOrderId = this._activeRoute.snapshot.params.bulkOrderId;
    this.store.dispatch({ type: BulkOrdersActionTypes.LOAD_BULK_ORDER_DETAILS, payload: bulkOrderId });
    this.orderItems$ = this.store.select(getBulkOrderByOrderId);
    this.orderItems$.subscribe(detailsResp => {
      this.loading = false;
      if (detailsResp) {
        this.orderDetails = detailsResp;
        let mappedItems = this.orderDetails?.orderItems.map((itemRes: any) => {
          return {
            shipToAccountNumber: itemRes.shipToAccountNumber,
            upc: itemRes?.lineItems[0]?.frame.upc,
            jobtype: '',
            orderType: itemRes?.lineItems[0]?.orderType,
            patientName: itemRes?.fullName,
            rxId: itemRes?.lineItems[0]?.rxId,
            status: itemRes?.status,
            frame: itemRes?.lineItems[0].frame,
            orderInfo: itemRes,
            poNumber: itemRes?.lineItems[0].poNumber,
          };
        });
        this.bulkOrderLineItems = mappedItems;
      }
    });
  }
}
